<template>
    <v-card :color="getColorCard" class="card-container kimsa-elevation" @click="$emit('click')">
        <div v-if="createMode">
            <v-icon color="#000000" size="100">mdi-folder-plus-outline</v-icon>
            <div class="bolder">
                {{ $t('common.create') }} {{ $t('common.folder') }}
            </div>
        </div>
        <div v-else-if="folder">
            <div v-if="canEdit" class="edit-btn" @click.stop="$emit('click:edit')">
                <v-btn icon x-small>
                    <v-icon>$edit</v-icon>
                </v-btn>
            </div>
            <v-img v-if="folder.img" :src="folder.img" height="100" />
            <v-icon v-else-if="folder.icon" :color="isActive ? '#FFFFFF' : '#000000'" size="100" class="pa-2">
                {{ folder.icon }}
            </v-icon>
            <v-icon v-else :color="isActive ? '#FFFFFF' : '#000000'" size="100">
                {{ isActive ? 'mdi-folder-open-outline' : 'mdi-folder-outline' }}
            </v-icon>
            <div class="bolder" :class="[{ 'white--text': isActive }, 'text-truncate']">
                {{ folder.name }}
            </div>
        </div>
    </v-card>
</template>

<script>
export default {
    name: "FolderCard",
    props: {
        createMode: {
            type: Boolean,
            default: false,
        },
        isActive: {
            type: Boolean,
            default: false,
        },
        folder: {
            type: Object,
            default: null,
        },
        noEdit: {
            type: Boolean,
            default: false,
        }
    },
    computed: {
        getColorCard(vm = this) {
            if (vm.createMode) return '#CCFF99'
            return vm.isActive ? 'secondary' : ''
        },
        canEdit(vm = this) {
            if (vm.noEdit) return false
            return vm.folder?.coachId
        }
    },
}
</script>

<style scoped>
.card-container {
    text-align: center;
    overflow: hidden;
    border-radius: 0;
}

.edit-btn {
    position: absolute;
    z-index: 1;
    right: 0;
    top: 0;
    background: rgba(0, 0, 0, .05);
    padding: 6px 4px;
    border-radius: 0 0 0 8px;
}
</style>